import { Environment } from '@atlassiansox/bxpkit-core';
import { SignupLayoutAnalytics } from '..';
import {
  CheckExtendedTrialAvailabilityOptionsType,
  CheckExtendedTrialAvailabilityResponseType,
  GetMigrationDataOptionsType,
  MigrationDataType,
  SitesType
} from '../../model';
import {
  MIGRATION_AGENTS_LABEL_KEY,
  MIGRATION_USERS_LABEL_KEY,
  WAC_SIGNUP_FORM_KEY_BASE
} from '../../layouts/legacy/view/utility/sign-up-layout-container/constants';

export const getMigrationData = async ({
  queryParameters,
  analyticsTrack,
  productKeys,
  userInfo,
  labels
}: GetMigrationDataOptionsType): Promise<MigrationDataType | null> => {
  const analytics = new SignupLayoutAnalytics({
    analyticsTrack,
    isLoggedIn: userInfo?.isLoggedIn
  });
  const migrationSourceUuid = queryParameters.hasOwnProperty(
    'migrationSourceUuid'
  )
    ? queryParameters.migrationSourceUuid
    : null;
  let product = null;
  let sites: SitesType = null;

  if (
    migrationSourceUuid &&
    userInfo.email &&
    userInfo.sites &&
    productKeys &&
    productKeys.length > 0 &&
    productKeys[0].productContent
  ) {
    product = productKeys[0].productContent[0];
    sites = userInfo.sites || [];
  } else {
    return Promise.resolve(null);
  }

  const humanUsageType = (usageType: string) => {
    switch (usageType) {
      case 'remote-agent-tier':
      case 'bamboo-agent-tier':
      case 'servicedesk-agent-tier':
        return labels[
          `${WAC_SIGNUP_FORM_KEY_BASE}${MIGRATION_AGENTS_LABEL_KEY}`
        ];
      default:
        return labels[
          `${WAC_SIGNUP_FORM_KEY_BASE}${MIGRATION_USERS_LABEL_KEY}`
        ];
    }
  };

  const cloudIds = sites ? sites.map((site) => site.cloudId) : null;

  if (!product?.productKey || !cloudIds) {
    return Promise.resolve(null);
  }

  const data = await checkExtendedTrialAvailability({
    migrationSourceUuid,
    productKey: product.productKey,
    cloudIds
  }).catch((err: Error) => {
    // tslint:disable-next-line:no-console
    console.log(err);
    return null;
  });

  if (!data) {
    return Promise.resolve(null);
  }

  const status = data.cloudCreation;

  const eligibleSites = data.sites
    ? Object.keys(data.sites).filter((cloudId) => data.sites[cloudId].available)
    : [];

  analytics.setIsMigration(true);
  return Promise.resolve({
    migrationSourceUuid,
    migrationUserLimit: data.usageLimit || 0,
    migrationUserType: humanUsageType(data.usageType),
    migrationProductName: product.productName,
    migrationSites: eligibleSites,
    invalidMigration: !status.available,
    claimedMigration: status.reason === 'ALREADY_CLAIMED'
  });
};

const checkExtendedTrialAvailability = async ({
  migrationSourceUuid,
  productKey,
  cloudIds
}: CheckExtendedTrialAvailabilityOptionsType): Promise<CheckExtendedTrialAvailabilityResponseType | void> => {
  const url = `${Environment.getHamletUrl()}/1.0/public/account/${migrationSourceUuid}/extendedTrial/availability`;
  const options = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      productKey,
      cloudIds
    }),
    withCredentials: true
  };

  const response = await fetch(url, options);
  if (response.ok) {
    return Promise.resolve(response.json());
  } else {
    return Promise.resolve();
  }
};
